
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webp-to-jpg-converter",
      function () {
        return require("private-next-pages/webp-to-jpg-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webp-to-jpg-converter"])
      });
    }
  